// import service from '@/services/admin/event'
import serviceCRM from '@/services/cliente/cliente'
import serviceEmisor from '@/services/facturacion/emisor'

const getDefaultState = () => ({
  emisorJIT: {},
  codigoActividad: '',
  local: '',
  terminal: ''
})

export const state = () => getDefaultState()

export const mutations = {
  SET_EMISOR_JIT: (state, { codigoActividad, local, terminal, ...emisorJIT }) => {
    state.emisorJIT = emisorJIT
    state.codigoActividad = codigoActividad[0].codigoActividad.id
    state.local = local[0].id
    state.terminal = local[0].terminal[0].id
  }
}

export const actions = {
  loadJITEmisor: async ({ commit, rootGetters, dispatch, state }) => {
    if (state.emisorJIT.id) {
      console.log('emisorJIT ya existe cache ✅')
      return
    }

    console.log('[TEST] buscar emisorJIT', process.env.NUXT_ENV_STORYLABS_JIT_USER)
    const response = await serviceEmisor.readById(process.env.NUXT_ENV_STORYLABS_JIT_USER)
    console.log('[TEST] emisorJIT response', response)
    if (response) {
      const { codigoActividad, local, ...emisorJIT } = response[0]

      commit('SET_EMISOR_JIT', { codigoActividad, local, ...emisorJIT })
    }
  },
  createJITCustomer: async (
    { commit, rootGetters, dispatch },
    { plan, customerId, paymentMethod, facturaElectronica, tipoIdentificacion, identificacion, correoElectronico, _idCliente }
  ) => {
    // registra cliente en JIT de storylabs.
    const emisor = rootGetters['facturacion/emisorStore/getValues']

    const params = {
      ...(_idCliente && { _id: _idCliente }),
      emisor: { _id: process.env.NUXT_ENV_STORYLABS_JIT_EMISOR }, // emisor cuenta JIT de storylabs
      nombre: emisor.nombre, // emisor JIT customer
      identificacion: emisor.identificacion,
      nombreComercial: emisor.nombreComercial,
      ubicacion: emisor.ubicacion,
      telefono: emisor.telefono,
      correoElectronico: emisor.correoElectronico,
      correoElectronicoContacto: emisor.correoElectronico,
      ciclo: 'Oportunidad',
      customerId,
      paymentMethods: [paymentMethod],
      accion: [
        {
          _idUsuario: process.env.NUXT_ENV_STORYLABS_JIT_USER,
          tipo: 'Otros Medios',
          prodServ: `JIT app ${plan}`,
          detalle: 'Pago de suscripción',
          fecha: new Date()
        }
      ],

      // si tiene FE, sobreescribe los datos del cliente.
      ...(facturaElectronica && {
        identificacion: {
          tipo: {
            id: tipoIdentificacion.id
          },
          numero: identificacion
        },
        correoElectronico: correoElectronico
      })
    }

    console.log('[TEST] JIT CUSTOMER params', params)

    const result = await serviceCRM.create({
      ...params,

      username: 'JIT payment bot'
    })

    console.log('[TEST] JIT CUSTOMER result', result)

    return result
  },
  // subscribeJITCustomer: async ({ commit, rootGetters, dispatch }, { _idJITCustomer, input }) => {
  //   console.log('[TEST] subscribeJITCustomer _id', { _idJITCustomer, input })
  //   const config = useRuntimeConfig()
  //   const { user } = useUserSession()

  //   const { response } = await crmClient.fetchAPI({
  //     method: 'subscribe',
  //     params: {
  //       _id: _idJITCustomer,
  //       input: {
  //         ...input,

  //         _idRef: user.value._idRoot,
  //         paymentWebhook: `${config.public.NUXT_PUBLIC_PAYMENT_WEBHOOK}/?_idUser=${user.value._idRoot}`
  //       }
  //     }
  //   })
  //   console.log('[TEST] subscribe response', response)

  //   return response
  // }
}
